export const UserActionTypes = {
  UPDATE_USER_BASIC_INFO: '@user/UPDATE_USER_BASIC_INFO'
};
